// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/bordered.less
// module id = 67
// module chunks = 0